import { createSlice } from "@reduxjs/toolkit";

const projectInfoSlice = createSlice({
    name: "projectInfo",
    initialState: {
        accessToken: null,
        uid: null,
        pubid: null,
        dev_id: null,
        channelid: null,
        logo: "",
        appConfig: null,
        app_id: null,
        community_block_post_add: false,
        community_block_comment_add: false,
        community_blocked: false,
        device_type: null,
        country_code: null,
    },
    reducers: {
        setProjectInfo(state, action) {
            state.accessToken = action.payload.accessToken;
            state.uid = action.payload.uid;
            state.pubid = action.payload.pubid;
            state.dev_id = action.payload.dev_id;
            state.channelid = action.payload.channelid;
            state.logo = action.payload.logo;
            state.app_id = action.payload.app_id;
            state.community_block_post_add = action.payload.community_block_post_add || false;
            state.community_block_comment_add = action.payload.community_block_comment_add || false;
            state.community_blocked = action.payload.community_blocked || false;
            state.device_type = action.payload.device_type || null;
            state.country_code = action.payload.country_code || null;
        },
    },
})
export const { setProjectInfo } = projectInfoSlice.actions;
export default projectInfoSlice.reducer;
